 
export class Laerer {
        public brugerId: string;
        public invitationId: string;
        public navn: string;
        public email: string;
        public ansvarlig: boolean;
        public selvTilmeldt: boolean;
        public uiId: string;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/Laerer.ts